import { OrgLogoRequestPresignedUrlRequestSchema, OrgLogoRequestPresignedUrlResponseSchema, OrgLogoConfirmUploadRequestSchema, OrgLogoConfirmUploadResponseSchema } from './upload-org-logo.schema';
/**
 * Request Presigned URL Endpoint Contract
 * Generates a presigned URL for direct upload to DigitalOcean Spaces
 */ export const orgLogoRequestPresignedUrlContract = {
    method: 'POST',
    path: '/api/v2/upload-org-logo/request-url',
    description: 'Request a presigned URL for org logo upload',
    requestSchema: OrgLogoRequestPresignedUrlRequestSchema,
    responseSchema: OrgLogoRequestPresignedUrlResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request',
            401: 'Unauthorized - invalid or missing token',
            500: 'Internal server error'
        }
    }
};
/**
 * Confirm Upload Endpoint Contract
 * Processes uploaded org logo and updates organization
 */ export const orgLogoConfirmUploadContract = {
    method: 'POST',
    path: '/api/v2/upload-org-logo/confirm',
    description: 'Confirm org logo upload and process image',
    requestSchema: OrgLogoConfirmUploadRequestSchema,
    responseSchema: OrgLogoConfirmUploadResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request or invalid image/SVG',
            401: 'Unauthorized - invalid or missing token',
            404: 'Organization not found',
            500: 'Internal server error'
        }
    }
};

//# sourceMappingURL=upload-org-logo.contract.js.map